import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer, WHATSAPP_URL } from '../utils/constants';
export function PainPoints() {
  const painPoints = [{
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80',
    title: 'Conflictos Legales Complejos',
    description: 'Disputas comerciales, societarias o contractuales que amenazan su patrimonio y estabilidad.'
  }, {
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80',
    title: 'Incertidumbre Jurídica',
    description: 'Desconoce sus derechos o las consecuencias legales de decisiones críticas para su negocio o familia.'
  }, {
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&q=80',
    title: 'Urgencia y Presión',
    description: 'Plazos legales que se acercan, notificaciones judiciales o situaciones que requieren acción inmediata.'
  }];
  return <section className="py-32 bg-white relative border-b border-grayMid" data-id="element-149">
      <div className="max-w-7xl mx-auto px-6" data-id="element-150">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} data-id="element-151">
          <motion.div variants={fadeUp} className="text-center mb-20" data-id="element-152">
            <h2 className="heading-brutalist text-3xl md:text-5xl mb-6 text-grayDarkest" data-id="element-153">
              ¿ENFRENTA ALGUNA DE ESTAS SITUACIONES?
            </h2>
            <div className="w-24 h-px bg-grayDarkest mx-auto" data-id="element-154"></div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-155">
            {painPoints.map((point, index) => <motion.div key={index} variants={fadeUp} className="bg-white border border-grayMid shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden flex flex-col" data-id="element-156">
                <div className="h-48 w-full overflow-hidden" data-id="element-157">
                  <img src={point.image} alt={point.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-158" />
                </div>
                <div className="p-8 flex-1 flex flex-col" data-id="element-159">
                  <h3 className="font-montserrat text-xl font-bold mb-4 uppercase tracking-wide text-grayDarkest" data-id="element-160">
                    {point.title}
                  </h3>
                  <p className="text-grayDarkest font-light leading-relaxed flex-1" data-id="element-161">
                    {point.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div variants={fadeUp} className="text-center bg-grayLightest border border-grayMid p-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-162">
            <p className="text-xl text-grayDarkest font-medium text-left" data-id="element-163">
              No tiene que enfrentarlo solo. Nuestro equipo está listo para
              actuar.
            </p>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="bg-grayDarkest text-white px-8 py-4 font-montserrat font-semibold uppercase tracking-wider hover:bg-grayMedium transition-colors duration-300 whitespace-nowrap" data-id="element-164">
              Hablar con un Abogado
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}